(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dogal-cart-extras')) {
    const orders = new Map();
    customElements.define('dogal-cart-extras', class extends HTMLElement {
      static observedAttributes = ['data-cart-key'];
      connectedCallback() {
        this.onVariantChange ||= event => {
          const select = event.target.closest('[data-dogal-cart-variant]');
          if (!select) return;
          queueMicrotask(() => {
            const option = select.selectedOptions[0];
            const price = select.closest('.dogal-cart-extra').querySelector('.dogal-cart-extra__price');
            if (!option?.dataset.price || !price) return;
            const current = document.createElement('span');
            current.textContent = option.dataset.price;
            price.replaceChildren(current);
            if (option.dataset.originalPrice) {
              const original = document.createElement('s');
              original.textContent = option.dataset.originalPrice;
              price.append(original);
            }
          });
        };
        this.addEventListener('change', this.onVariantChange);
        this.observer = new MutationObserver(() => this.queueShuffle());
        this.observer.observe(this, { childList: true, subtree: true });
        this.queueShuffle();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onVariantChange);
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      attributeChangedCallback() { this.queueShuffle(); }
      queueShuffle() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.shuffle());
      }
      shuffle() {
        const list = this.querySelector('.dogal-cart-extras__list');
        if (!list) return;
        const cards = Array.from(list.children);
        const ids = cards.map(card => card.dataset.productId);
        const signature = `${this.dataset.cartKey}|${ids.slice().sort().join(',')}`;
        if (this.signature === signature) return;
        this.signature = signature;
        let order = orders.get(signature);
        if (!order) {
          order = ids.slice();
          for (let i = order.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [order[i], order[j]] = [order[j], order[i]];
          }
          orders.set(signature, order);
        }
        const byId = new Map(cards.map(card => [card.dataset.productId, card]));
        const fragment = document.createDocumentFragment();
        order.forEach(id => { if (byId.has(id)) fragment.append(byId.get(id)); });
        list.append(fragment);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
